export enum PipeMaterial {
  CastIron = 'CAST_IRON',
  DuctileIron = 'DUCTILE_IRON',
  DuctileIronCl = 'DUCTILE_IRON_CL',
  Steel = 'STEEL',
  SteelCl = 'STEEL_CL',
  Copper = 'COPPER',
  Lead = 'LEAD',
  Ac = 'AC',
  Pccp = 'PCCP',
  Upvc = 'UPVC',
  Mdpe = 'MDPE',
  Hdpe = 'HDPE',
  Grp = 'GRP',
  PeAlPe = 'PE_AL_PE',
  Other = 'OTHER',
}
